import { styled, Typography } from "@mui/material";

export const DisplayToggleHeaderLink = styled(Typography)({
  fontWeight: 400,
  fontSize: "16px",
  lineHeight: "20px",
  letterSpacing: "0.5px",
  color: "secondary.dark",
});
